import { InjectionToken } from '@angular/core';

export interface AdyenConfig {
  account: {
    clientKey: string | undefined;
    platform: AdyenPlatform;
  };
  account_india: {
    clientKey: string | undefined;
    platform: AdyenPlatform;
  };
}

/**
 * Type representing the keys of account configurations in AdyenConfig
 */
export type AdyenAccountKey = 'account' | 'account_india';

/**
 * Type representing the platforms of Adyen SDK
 */
export type AdyenPlatform = 'test' | 'live' | 'live-in';

/**
 * Mapping of merchant account names to their corresponding config keys
 */
export const MERCHANT_ACCOUNT_MAP: Record<string, AdyenAccountKey> = {
  FreelancerMerchant_India: 'account_india',
  FreelancerCOM: 'account',
  FreelancerCOM_UK: 'account',
};

export const DEFAULT_MERCHANT_ACCOUNT = 'FreelancerCOM';

export const ADYEN_CONFIG = new InjectionToken<AdyenConfig>('AdyenConfig');
